import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import type { ReactNode } from 'react';
import { mergeSx } from '../../../../utils/styles';

const styles = {
  itemButton: {
    px: 1.5,
    py: 0.625,
    gap: 0.5,
    '&:hover': {
      backgroundColor: 'neutral.500',
    },
  },
  subtleSelectedItem: {
    '&.Mui-selected': {
      backgroundColor: 'secondary.450',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'secondary.450',
    },
    '&.Mui-selected .MuiTypography-root': {
      color: 'text.primary',
    },
  },
  solidSelectedItem: {
    '&.Mui-selected': {
      backgroundColor: 'secondary.450',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'secondary.450',
    },
  },
  icon: {
    display: 'inline-flex',
    minWidth: 28,
    color: 'secondary.200',
  },
  label: {
    '& .MuiTypography-root': {
      typography: { xs: 'body3', md: 'body3' },
      fontWeight: { xs: 600, md: 600 },
      letterSpacing: { xs: 0, md: 0 },
      color: 'neutral.100',
    },
  },
  solidSelectedLabel: {
    '& .MuiTypography-root': {
      color: 'neutral.50',
    },
  },
  endIcon: {
    ml: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
  },
} as const;

type NeobetSidebarListItemProps = {
  endIcon?: ReactNode;
  icon?: ReactNode | null;
  isSelected?: boolean;
  label: string;
  onClick: () => void;
  selectedVariant?: 'subtle' | 'solid';
};

const NeobetSidebarListItem = ({
  endIcon,
  icon,
  isSelected = false,
  label,
  onClick,
  selectedVariant = 'subtle',
}: NeobetSidebarListItemProps) => {
  const selectedItemStyle = selectedVariant === 'solid' ? styles.solidSelectedItem : styles.subtleSelectedItem;

  return (
    <ListItemButton
      onClick={onClick}
      selected={isSelected}
      sx={mergeSx(styles.itemButton, isSelected && selectedItemStyle)}
    >
      {icon === null ? null : (
        <ListItemIcon sx={styles.icon}>{icon ?? <ChevronRightRoundedIcon fontSize='small' />}</ListItemIcon>
      )}
      <ListItemText
        primary={label}
        sx={mergeSx(styles.label, isSelected && selectedVariant === 'solid' && styles.solidSelectedLabel)}
      />
      {endIcon ? (
        <Box component='span' sx={styles.endIcon}>
          {endIcon}
        </Box>
      ) : null}
    </ListItemButton>
  );
};

export default NeobetSidebarListItem;
